import React, { Component } from "react";
import {
    CButton,
    CCol,
    CRow,
    CTooltip,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { helps } from "src/_helpers";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

/**
 * ============================================================
 * SEKIN - PROJECT TIMEKEEPING EXPORT
 * VERSION 3
 * ============================================================
 *
 * KIẾN TRÚC:
 *
 * 1. Load MASTER TEMPLATE
 * 2. Đọc style / layout từ template
 * 3. Tạo WORKBOOK MỚI SẠCH
 * 4. Tạo worksheet mới
 * 5. Copy layout + style an toàn
 * 6. Ghi dữ liệu nhân viên
 * 7. Tạo dòng tổng
 * 8. Tạo khu vực ký
 * 9. Xuất XLSX mới
 *
 * KHÔNG:
 * - spliceRows()
 * - PizZip
 * - Docxtemplater
 * - sửa trực tiếp workbook template
 *
 * ============================================================
 *
 * TEMPLATE:
 *
 * /public/templates/tpl_bang_cham_cong.xlsx
 *
 * ============================================================
 *
 * CẤU TRÚC:
 *
 * A  = STT
 * B  = Họ & Tên
 * C  = Ngày 1
 * ...
 * AG = Ngày 31
 * AH = Tổng giờ
 * AI = Tổng ngày
 *
 * Row 7  = Ngày
 * Row 8  = Thứ
 * Row 9+ = Nhân viên
 * Total  = Tổng giờ/ngày
 *
 * ============================================================
 */

export default class ProjectTimeKeepingExport extends Component {

    constructor(props) {
        super(props);

        this.handleExport =
            this.handleExport.bind(this);
    }

    // =========================================================
    // DATE
    // =========================================================

    toDate(value) {

        if (!value) {
            return null;
        }

        if (
            value instanceof Date
        ) {
            return isNaN(
                value.getTime()
            )
                ? null
                : value;
        }

        if (
            value &&
            typeof value.toDate ===
            "function"
        ) {
            const date =
                value.toDate();

            return isNaN(
                date.getTime()
            )
                ? null
                : date;
        }

        if (
            value &&
            typeof value.seconds ===
            "number"
        ) {
            const date =
                new Date(
                    value.seconds *
                    1000
                );

            return isNaN(
                date.getTime()
            )
                ? null
                : date;
        }

        const date =
            new Date(value);

        return isNaN(
            date.getTime()
        )
            ? null
            : date;
    }

    getMonthDate() {

        const {
            month,
        } = this.props;

        return (
            this.toDate(
                month
            ) ||
            new Date()
        );
    }

    getDaysInMonth() {

        const date =
            this.getMonthDate();

        return new Date(
            date.getFullYear(),
            date.getMonth() + 1,
            0
        ).getDate();
    }

    // =========================================================
    // FORMAT
    // =========================================================

    round(value) {

        const number =
            Number(value);

        if (
            !Number.isFinite(
                number
            )
        ) {
            return 0;
        }

        return (
            Math.round(
                (
                    number +
                    Number.EPSILON
                ) *
                100
            ) / 100
        );
    }

    formatHours(value) {

        const number =
            this.round(value);

        if (
            Number.isInteger(
                number
            )
        ) {
            return String(
                number
            );
        }

        return number
            .toFixed(2)
            .replace(
                /0+$/,
                ""
            )
            .replace(
                /\.$/,
                ""
            );
    }

    formatMonth(date) {

        const mm =
            String(
                date.getMonth() +
                1
            ).padStart(
                2,
                "0"
            );

        return (
            mm +
            "/" +
            date.getFullYear()
        );
    }

    formatExportDate(date) {

        return (
            "ngày " +
            date.getDate() +
            " tháng " +
            (
                date.getMonth() +
                1
            ) +
            " năm " +
            date.getFullYear()
        );
    }

    sanitizeFileName(value) {

        return String(
            value ||
            "MucTieu"
        )
            .replace(
                /[\\/:*?"<>|]/g,
                "-"
            )
            .replace(
                /\s+/g,
                " "
            )
            .trim();
    }

    // =========================================================
    // WEEKDAY
    // =========================================================

    getVietnameseWeekday(
        date
    ) {

        const day =
            date.getDay();

        const map = {
            0: "CN",
            1: "T2",
            2: "T3",
            3: "T4",
            4: "T5",
            5: "T6",
            6: "T7",
        };

        return map[day] || "";
    }

    // =========================================================
    // EMPLOYEE
    // =========================================================

    getEmployees() {

        const {
            checks = [],
            employees = [],
            project = {},
        } = this.props;

        console.log(
            "[SEKIN] ========================================"
        );

        console.log(
            "[SEKIN] RESOLVE EMPLOYEES FOR EXPORT"
        );

        console.log(
            "[SEKIN] All employees:",
            Array.isArray(
                employees
            )
                ? employees.length
                : 0
        );

        console.log(
            "[SEKIN] Checks:",
            Array.isArray(
                checks
            )
                ? checks.length
                : 0
        );

        // -----------------------------------------------------
        // Tạo Map employee
        // -----------------------------------------------------

        const employeeMap =
            new Map();

        if (
            Array.isArray(
                employees
            )
        ) {

            employees.forEach(
                (
                    employee
                ) => {

                    if (
                        employee &&
                        employee.employee_id
                    ) {

                        employeeMap.set(
                            String(
                                employee.employee_id
                            ),
                            employee
                        );
                    }
                }
            );
        }

        // -----------------------------------------------------
        // ƯU TIÊN checks
        // -----------------------------------------------------

        if (
            Array.isArray(
                checks
            ) &&
            checks.length > 0
        ) {

            const employeeIds =
                [];

            checks.forEach(
                (
                    check
                ) => {

                    if (
                        !check ||
                        !check.employee_id
                    ) {
                        return;
                    }

                    const id =
                        String(
                            check.employee_id
                        );

                    if (
                        !employeeIds.includes(
                            id
                        )
                    ) {

                        employeeIds.push(
                            id
                        );
                    }
                }
            );

            console.log(
                "[SEKIN] Unique employee IDs from checks:",
                employeeIds.length
            );

            const result =
                employeeIds.map(
                    (
                        employeeId
                    ) => {

                        const found =
                            employeeMap.get(
                                String(
                                    employeeId
                                )
                            );

                        if (
                            found
                        ) {
                            return found;
                        }

                        console.warn(
                            "[SEKIN] Employee not found:",
                            employeeId
                        );

                        return {
                            employee_id:
                                employeeId,

                            fullname:
                                employeeId,
                        };
                    }
                );

            console.log(
                "[SEKIN] Resolved employees:",
                result.length
            );

            return result;
        }

        // -----------------------------------------------------
        // Nếu checks rỗng
        // -----------------------------------------------------

        if (
            project &&
            Array.isArray(
                project.employees
            ) &&
            project.employees.length
        ) {

            console.log(
                "[SEKIN] Checks empty -> project.employees:",
                project.employees.length
            );

            return project.employees;
        }

        // -----------------------------------------------------
        // Fallback
        // -----------------------------------------------------

        if (
            Array.isArray(
                employees
            )
        ) {

            return employees;
        }

        return [];
    }

    // =========================================================
    // CHECKS
    // =========================================================

    getChecks() {

        const {
            checks = [],
        } = this.props;

        if (
            !Array.isArray(
                checks
            )
        ) {

            console.warn(
                "[SEKIN] checks is not array:",
                checks
            );

            return [];
        }

        console.log(
            "[SEKIN] CHECK COUNT:",
            checks.length
        );

        if (
            checks.length > 0
        ) {

            console.log(
                "[SEKIN] FIRST CHECK:",
                checks[0]
            );
        }

        return checks;
    }

    // =========================================================
    // BUILD EXPORT DATA
    // =========================================================

    buildExportData() {

        const employees =
            this.getEmployees();

        const checks =
            this.getChecks();

        const monthDate =
            this.getMonthDate();

        const daysInMonth =
            this.getDaysInMonth();

        console.log(
            "[SEKIN] ========================================"
        );

        console.log(
            "[SEKIN] BUILD EXPORT DATA"
        );

        console.log(
            "[SEKIN] employees:",
            employees.length
        );

        console.log(
            "[SEKIN] checks:",
            checks.length
        );

        console.log(
            "[SEKIN] month:",
            monthDate
        );

        console.log(
            "[SEKIN] days:",
            daysInMonth
        );

        console.log(
            "[SEKIN] ========================================"
        );

        const result = [];

        employees.forEach(
            (
                employee,
                employeeIndex
            ) => {

                if (
                    !employee
                ) {
                    return;
                }

                const employeeId =
                    employee.employee_id ||
                    "";

                const fullname =
                    employee.fullname ||
                    "";

                // ------------------------------------------------
                // LẤY CHECKS CỦA EMPLOYEE
                // ------------------------------------------------

                const employeeChecks =
                    checks.filter(
                        (
                            check
                        ) => {

                            if (
                                !check ||
                                !check.employee_id
                            ) {
                                return false;
                            }

                            return (
                                String(
                                    check.employee_id
                                ) ===
                                String(
                                    employeeId
                                )
                            );
                        }
                    );

                console.log(
                    "[SEKIN] Employee:",
                    employeeIndex + 1,
                    fullname,
                    employeeId,
                    "checks:",
                    employeeChecks.length
                );

                const days = [];

                let regularTotal =
                    0;

                let overtimeTotal =
                    0;

                // ------------------------------------------------
                // TỪNG NGÀY
                // ------------------------------------------------

                for (
                    let day = 1;
                    day <= daysInMonth;
                    day++
                ) {

                    const dayChecks =
                        employeeChecks.filter(
                            (
                                check
                            ) => {

                                const checkDate =
                                    this.toDate(
                                        check.check_date
                                    );

                                if (
                                    !checkDate
                                ) {
                                    return false;
                                }

                                return (
                                    checkDate.getFullYear() ===
                                    monthDate.getFullYear() &&
                                    checkDate.getMonth() ===
                                    monthDate.getMonth() &&
                                    checkDate.getDate() ===
                                    day
                                );
                            }
                        );

                    let regularHours =
                        0;

                    let overtimeHours =
                        0;

                    dayChecks.forEach(
                        (
                            check
                        ) => {

                            const durationMinutes =
                                Number(
                                    check.check_duration ||
                                    0
                                );

                            if (
                                !Number.isFinite(
                                    durationMinutes
                                )
                            ) {
                                return;
                            }

                            const durationHours =
                                durationMinutes /
                                60;

                            if (
                                check.is_overtime
                            ) {

                                overtimeHours +=
                                    durationHours;

                            } else {

                                regularHours +=
                                    durationHours;
                            }
                        }
                    );

                    regularHours =
                        this.round(
                            regularHours
                        );

                    overtimeHours =
                        this.round(
                            overtimeHours
                        );

                    let display =
                        "";

                    if (
                        regularHours >
                        0
                    ) {

                        display =
                            this.formatHours(
                                regularHours
                            );
                    }

                    if (
                        overtimeHours >
                        0
                    ) {

                        display +=
                            `(${this.formatHours(
                                overtimeHours
                            )})`;
                    }

                    days.push({

                        day,

                        regularHours,

                        overtimeHours,

                        totalHours:
                            this.round(
                                regularHours +
                                overtimeHours
                            ),

                        display,
                    });

                    regularTotal +=
                        regularHours;

                    overtimeTotal +=
                        overtimeHours;

                    // ------------------------------------------------
                    // DEBUG ngày có dữ liệu
                    // ------------------------------------------------

                    if (
                        dayChecks.length >
                        0
                    ) {

                        console.log(
                            "[SEKIN] DAY DATA:",
                            {
                                employee:
                                    fullname,

                                employeeId,

                                day,

                                checkCount:
                                    dayChecks.length,

                                regularHours,

                                overtimeHours,

                                display,
                            }
                        );
                    }
                }

                regularTotal =
                    this.round(
                        regularTotal
                    );

                overtimeTotal =
                    this.round(
                        overtimeTotal
                    );

                const totalHours =
                    this.round(
                        regularTotal +
                        overtimeTotal
                    );

                const workingDays =
                    this.round(
                        regularTotal /
                        12
                    );

                result.push({

                    index:
                        employeeIndex +
                        1,

                    fullname,

                    employee_id:
                        employeeId,

                    days,

                    regularTotal,

                    overtimeTotal,

                    totalHours,

                    workingDays,
                });

                console.log(
                    "[SEKIN] EMPLOYEE RESULT:",
                    {
                        index:
                            employeeIndex +
                            1,

                        fullname,

                        employee_id:
                            employeeId,

                        regularTotal,

                        overtimeTotal,

                        totalHours,

                        workingDays,
                    }
                );
            }
        );

        console.log(
            "[SEKIN] FINAL EXPORT DATA COUNT:",
            result.length
        );

        return result;
    }

    // =========================================================
    // COPY CELL STYLE
    // =========================================================

    copyCellStyle(
        sourceCell,
        targetCell
    ) {

        if (
            sourceCell.font
        ) {

            targetCell.font =
            {
                ...sourceCell.font,
            };
        }

        if (
            sourceCell.fill
        ) {

            targetCell.fill =
            {
                ...sourceCell.fill,
            };
        }

        if (
            sourceCell.border
        ) {

            targetCell.border =
            {
                ...sourceCell.border,
            };
        }

        if (
            sourceCell.alignment
        ) {

            targetCell.alignment =
            {
                ...sourceCell.alignment,
            };
        }

        if (
            sourceCell.protection
        ) {

            targetCell.protection =
            {
                ...sourceCell.protection,
            };
        }

        if (
            sourceCell.numFmt
        ) {

            targetCell.numFmt =
                sourceCell.numFmt;
        }
    }

    // =========================================================
    // COPY ROW
    // =========================================================

    copyRow(
        sourceWorksheet,
        targetWorksheet,
        sourceRowNumber,
        targetRowNumber,
        copyValues = true
    ) {

        const sourceRow =
            sourceWorksheet.getRow(
                sourceRowNumber
            );

        const targetRow =
            targetWorksheet.getRow(
                targetRowNumber
            );

        if (
            sourceRow.height
        ) {

            targetRow.height =
                sourceRow.height;
        }

        targetRow.hidden =
            sourceRow.hidden;

        for (
            let col = 1;
            col <= 35;
            col++
        ) {

            const sourceCell =
                sourceRow.getCell(
                    col
                );

            const targetCell =
                targetRow.getCell(
                    col
                );

            this.copyCellStyle(
                sourceCell,
                targetCell
            );

            if (
                copyValues
            ) {

                const value =
                    sourceCell.value;

                /**
                 * Không copy formula từ template.
                 * Formula sẽ được tạo mới nếu cần.
                 */
                if (
                    value &&
                    typeof value ===
                    "object" &&
                    value.formula
                ) {

                    targetCell.value =
                        null;

                } else {

                    targetCell.value =
                        value;
                }
            }
        }
    }

    // =========================================================
    // COPY MERGE
    // =========================================================

    copyMerge(
        targetWorksheet,
        mergeAddress
    ) {

        try {

            targetWorksheet.mergeCells(
                mergeAddress
            );

        } catch (
        error
        ) {

            console.warn(
                "[SEKIN] Cannot merge:",
                mergeAddress,
                error.message
            );
        }
    }

    // =========================================================
    // BUILD CLEAN WORKBOOK
    // =========================================================

    async createCleanWorkbook(
        templateWorksheet,
        exportData,
        monthDate,
        daysInMonth,
        projectName,
        areaName
    ) {

        console.log(
            "[SEKIN] ========================================"
        );

        console.log(
            "[SEKIN] CREATE CLEAN WORKBOOK"
        );

        console.log(
            "[SEKIN] ========================================"
        );

        const workbook =
            new ExcelJS.Workbook();

        workbook.creator =
            "SEKIN Security";

        workbook.lastModifiedBy =
            "SEKIN Security";

        workbook.created =
            new Date();

        workbook.modified =
            new Date();

        // =====================================================
        // MAIN SHEET
        // =====================================================

        const worksheet =
            workbook.addWorksheet(
                "Bảng chấm công"
            );

        // -----------------------------------------------------
        // Sheet settings
        // -----------------------------------------------------

        worksheet.showGridLines =
            false;

        worksheet.views = [
            {
                state:
                    "normal",
                showGridLines:
                    false,
            },
        ];

        // =====================================================
        // COLUMN WIDTHS
        // =====================================================

        for (
            let col = 1;
            col <= 35;
            col++
        ) {

            const sourceColumn =
                templateWorksheet.getColumn(
                    col
                );

            const targetColumn =
                worksheet.getColumn(
                    col
                );

            if (
                sourceColumn.width
            ) {

                targetColumn.width =
                    sourceColumn.width;
            }

            targetColumn.hidden =
                sourceColumn.hidden;
        }

        // Default nếu template không có width
        if (
            !worksheet.getColumn(1)
                .width
        ) {
            worksheet.getColumn(1)
                .width = 5;
        }

        worksheet.getColumn(2)
            .width = 27;

        for (
            let col = 3;
            col <= 33;
            col++
        ) {

            worksheet.getColumn(
                col
            ).width = 5.3;
        }

        worksheet.getColumn(34)
            .width = 11;

        worksheet.getColumn(35)
            .width = 11;

        // =====================================================
        // HEADER ROWS 1-8
        // =====================================================

        for (
            let rowNumber = 1;
            rowNumber <= 8;
            rowNumber++
        ) {

            this.copyRow(
                templateWorksheet,
                worksheet,
                rowNumber,
                rowNumber,
                true
            );
        }

        // =====================================================
        // HEADER CONTENT
        // =====================================================

        // Row 1
        worksheet.getCell(
            "A1"
        ).value =
            "SEKIN SECURITY";

        // Row 2
        worksheet.getCell(
            "A2"
        ).value =
            "BẢNG CHẤM CÔNG";

        // Row 4
        worksheet.getCell(
            "A4"
        ).value =
            `Mục tiêu: ${projectName}`;

        worksheet.getCell(
            "E4"
        ).value =
            `Khu vực: ${areaName || ""}`;

        worksheet.getCell(
            "I4"
        ).value =
            `Tháng: ${this.formatMonth(
                monthDate
            )}`;

        worksheet.getCell(
            "M4"
        ).value =
            `Ngày xuất: ${this.formatExportDate(
                new Date()
            )}`;

        // Row 5
        worksheet.getCell(
            "A5"
        ).value =
            "Quy ước: Giờ công trong ngày ghi trực tiếp; giờ tăng ca có thể ghi trong ngoặc, ví dụ 12 (4).";

        // =====================================================
        // MERGES HEADER
        // =====================================================

        const headerMerges = [
            "A1:AI1",
            "A2:AI2",
            "A4:D4",
            "E4:H4",
            "I4:L4",
            "M4:AI4",
            "A5:AI5",
        ];

        headerMerges.forEach(
            (
                merge
            ) => {

                this.copyMerge(
                    worksheet,
                    merge
                );
            }
        );

        // =====================================================
        // DAY HEADER
        // =====================================================

        worksheet.getCell(
            "A7"
        ).value =
            "#";

        worksheet.getCell(
            "B7"
        ).value =
            "Họ & Tên";

        worksheet.getCell(
            "A8"
        ).value =
            "";

        worksheet.getCell(
            "B8"
        ).value =
            "Thứ";

        for (
            let day = 1;
            day <= 31;
            day++
        ) {

            const column =
                day + 2;

            const dayCell =
                worksheet.getCell(
                    7,
                    column
                );

            const weekdayCell =
                worksheet.getCell(
                    8,
                    column
                );

            if (
                day <=
                daysInMonth
            ) {

                dayCell.value =
                    day;

                const date =
                    new Date(
                        monthDate.getFullYear(),
                        monthDate.getMonth(),
                        day
                    );

                weekdayCell.value =
                    this.getVietnameseWeekday(
                        date
                    );

            } else {

                dayCell.value =
                    "";

                weekdayCell.value =
                    "";
            }
        }

        worksheet.getCell(
            "AH7"
        ).value =
            "Tổng giờ";

        worksheet.getCell(
            "AI7"
        ).value =
            "Tổng ngày";

        worksheet.getCell(
            "AH8"
        ).value =
            "Giờ";

        worksheet.getCell(
            "AI8"
        ).value =
            "Ngày";

        // =====================================================
        // DATA ROW STYLE
        // =====================================================

        const dataStyleSource =
            templateWorksheet.getRow(
                9
            );

        const totalStyleSource =
            templateWorksheet.getRow(
                19
            );

        // =====================================================
        // EMPLOYEE ROWS
        // =====================================================

        const firstDataRow =
            9;

        exportData.forEach(
            (
                item,
                index
            ) => {

                const rowNumber =
                    firstDataRow +
                    index;

                const row =
                    worksheet.getRow(
                        rowNumber
                    );

                // Copy style từ row mẫu
                this.copyRow(
                    templateWorksheet,
                    worksheet,
                    9,
                    rowNumber,
                    false
                );

                // ------------------------------------------------
                // A = STT
                // ------------------------------------------------

                row.getCell(
                    1
                ).value =
                    item.index;

                // ------------------------------------------------
                // B = Họ tên
                // ------------------------------------------------

                row.getCell(
                    2
                ).value =
                    item.fullname || "";

                // ------------------------------------------------
                // C:AG = ngày
                // ------------------------------------------------

                for (
                    let day = 1;
                    day <= 31;
                    day++
                ) {

                    const column =
                        day + 2;

                    const cell =
                        row.getCell(
                            column
                        );

                    if (
                        day <=
                        daysInMonth
                    ) {

                        const dayData =
                            item.days[
                            day - 1
                            ];

                        cell.value =
                            dayData
                                ? dayData.display
                                : "";

                    } else {

                        cell.value =
                            "";
                    }

                    cell.alignment =
                    {
                        ...(cell.alignment ||
                            {}),

                        horizontal:
                            "center",

                        vertical:
                            "center",

                        wrapText:
                            true,
                    };
                }

                // ------------------------------------------------
                // AH = Tổng giờ
                // ------------------------------------------------

                row.getCell(
                    34
                ).value =
                    item.totalHours;

                row.getCell(
                    34
                ).numFmt =
                    "0.00";

                // ------------------------------------------------
                // AI = Tổng ngày
                // ------------------------------------------------

                row.getCell(
                    35
                ).value =
                    item.workingDays;

                row.getCell(
                    35
                ).numFmt =
                    "0.00";

                row.height =
                    dataStyleSource.height ||
                    23;

                console.log(
                    "[SEKIN] CLEAN WORKBOOK ROW:",
                    rowNumber,
                    {
                        A:
                            row.getCell(
                                1
                            ).value,

                        B:
                            row.getCell(
                                2
                            ).value,

                        C:
                            row.getCell(
                                3
                            ).value,

                        AH:
                            row.getCell(
                                34
                            ).value,

                        AI:
                            row.getCell(
                                35
                            ).value,
                    }
                );
            }
        );

        // =====================================================
        // TOTAL ROW
        // =====================================================

        const totalRowNumber =
            firstDataRow +
            exportData.length;

        const totalRow =
            worksheet.getRow(
                totalRowNumber
            );

        this.copyRow(
            templateWorksheet,
            worksheet,
            19,
            totalRowNumber,
            false
        );

        totalRow.getCell(
            1
        ).value =
            "";

        totalRow.getCell(
            2
        ).value =
            "Tổng giờ/ngày:";

        // -----------------------------------------------------
        // Tổng từng ngày
        // -----------------------------------------------------

        for (
            let day = 1;
            day <= 31;
            day++
        ) {

            const column =
                day + 2;

            const cell =
                totalRow.getCell(
                    column
                );

            if (
                day >
                daysInMonth
            ) {

                cell.value =
                    "";

                continue;
            }

            let total =
                0;

            exportData.forEach(
                (
                    employee
                ) => {

                    const dayData =
                        employee.days[
                        day - 1
                        ];

                    if (
                        dayData
                    ) {

                        total +=
                            Number(
                                dayData.totalHours ||
                                0
                            );
                    }
                }
            );

            cell.value =
                this.round(
                    total
                );

            cell.numFmt =
                "0.00";

            cell.alignment =
            {
                ...(cell.alignment ||
                    {}),

                horizontal:
                    "center",

                vertical:
                    "center",
            };
        }

        // -----------------------------------------------------
        // Tổng giờ
        // -----------------------------------------------------

        const grandTotalHours =
            exportData.reduce(
                (
                    sum,
                    employee
                ) =>
                    sum +
                    Number(
                        employee.totalHours ||
                        0
                    ),
                0
            );

        totalRow.getCell(
            34
        ).value =
            this.round(
                grandTotalHours
            );

        totalRow.getCell(
            34
        ).numFmt =
            "0.00";

        // -----------------------------------------------------
        // Tổng ngày
        // -----------------------------------------------------

        const grandTotalDays =
            exportData.reduce(
                (
                    sum,
                    employee
                ) =>
                    sum +
                    Number(
                        employee.workingDays ||
                        0
                    ),
                0
            );

        totalRow.getCell(
            35
        ).value =
            this.round(
                grandTotalDays
            );

        totalRow.getCell(
            35
        ).numFmt =
            "0.00";

        totalRow.height =
            totalStyleSource.height ||
            25;

        console.log(
            "[SEKIN] CLEAN WORKBOOK TOTAL:",
            {
                row:
                    totalRowNumber,

                totalHours:
                    this.round(
                        grandTotalHours
                    ),

                totalDays:
                    this.round(
                        grandTotalDays
                    ),
            }
        );

        // =====================================================
        // SIGNATURE BLOCK
        // =====================================================

        /**
         * Template:
         *
         * Total row = 19
         * Signature starts = 22
         *
         * Khoảng cách = 2 dòng trống
         *
         * Với N employee:
         *
         * totalRow = 9 + N
         *
         * signatureStart =
         * totalRow + 3
         */

        const signatureStart =
            totalRowNumber +
            3;

        console.log(
            "[SEKIN] Signature start row:",
            signatureStart
        );

        /**
         * Copy row 20,21 làm khoảng trống.
         */
        this.copyRow(
            templateWorksheet,
            worksheet,
            20,
            totalRowNumber + 1,
            true
        );

        this.copyRow(
            templateWorksheet,
            worksheet,
            21,
            totalRowNumber + 2,
            true
        );

        // -----------------------------------------------------
        // Signature rows 22-27
        // -----------------------------------------------------

        for (
            let sourceRow = 22;
            sourceRow <= 27;
            sourceRow++
        ) {

            const targetRow =
                signatureStart +
                (
                    sourceRow -
                    22
                );

            this.copyRow(
                templateWorksheet,
                worksheet,
                sourceRow,
                targetRow,
                true
            );
        }

        // -----------------------------------------------------
        // Shift signature merges
        // -----------------------------------------------------

        const signatureMerges = [
            {
                source:
                    22,
                target:
                    signatureStart,
                ranges: [
                    "A22:L22",
                    "M22:W22",
                    "X22:AI22",
                ],
            },

            {
                source:
                    23,
                target:
                    signatureStart +
                    1,
                ranges: [
                    "A23:L23",
                    "M23:W23",
                    "X23:AI23",
                ],
            },

            {
                source:
                    27,
                target:
                    signatureStart +
                    5,
                ranges: [
                    "A27:L27",
                    "M27:W27",
                    "X27:AI27",
                ],
            },
        ];

        signatureMerges.forEach(
            (
                block
            ) => {

                const offset =
                    block.target -
                    block.source;

                block.ranges.forEach(
                    (
                        range
                    ) => {

                        const shifted =
                            this.shiftRange(
                                range,
                                offset
                            );

                        this.copyMerge(
                            worksheet,
                            shifted
                        );
                    }
                );
            }
        );

        // -----------------------------------------------------
        // Signature placeholders
        // -----------------------------------------------------

        worksheet.getCell(
            signatureStart,
            1
        ).value =
            "NGƯỜI LẬP BẢNG";

        worksheet.getCell(
            signatureStart,
            13
        ).value =
            "CHỈ HUY MỤC TIÊU";

        worksheet.getCell(
            signatureStart,
            24
        ).value =
            "XÁC NHẬN KHÁCH HÀNG";

        worksheet.getCell(
            signatureStart + 1,
            1
        ).value =
            "Ngày .... tháng .... năm ....";

        worksheet.getCell(
            signatureStart + 1,
            13
        ).value =
            "Ngày .... tháng .... năm ....";

        worksheet.getCell(
            signatureStart + 1,
            24
        ).value =
            "Ngày .... tháng .... năm ....";

        worksheet.getCell(
            signatureStart + 5,
            1
        ).value =
            "";

        worksheet.getCell(
            signatureStart + 5,
            13
        ).value =
            "";

        worksheet.getCell(
            signatureStart + 5,
            24
        ).value =
            "";

        // =====================================================
        // PAGE SETUP
        // =====================================================

        worksheet.pageSetup =
        {
            orientation:
                "landscape",

            paperSize:
                9,

            fitToPage:
                true,

            fitToWidth:
                1,

            fitToHeight:
                0,

            horizontalCentered:
                true,

            verticalCentered:
                false,

            margins:
            {
                left:
                    0.2,

                right:
                    0.2,

                top:
                    0.4,

                bottom:
                    0.4,

                header:
                    0.2,

                footer:
                    0.2,
            },
        };

        worksheet.pageSetup.printArea =
            `A1:AI${signatureStart + 5}`;

        // =====================================================
        // FREEZE
        // =====================================================

        worksheet.views = [
            {
                state:
                    "frozen",

                xSplit:
                    2,

                ySplit:
                    8,

                showGridLines:
                    false,
            },
        ];

        console.log(
            "[SEKIN] Clean workbook created successfully."
        );

        return workbook;
    }

    // =========================================================
    // SHIFT EXCEL RANGE
    // =========================================================

    shiftRange(
        range,
        rowOffset
    ) {

        const match =
            range.match(
                /^([A-Z]+)(\d+):([A-Z]+)(\d+)$/
            );

        if (
            !match
        ) {

            return range;
        }

        const startCol =
            match[1];

        const startRow =
            Number(
                match[2]
            );

        const endCol =
            match[3];

        const endRow =
            Number(
                match[4]
            );

        return (
            startCol +
            (
                startRow +
                rowOffset
            ) +
            ":" +
            endCol +
            (
                endRow +
                rowOffset
            )
        );
    }

    // =========================================================
    // README
    // =========================================================

    createReadme(
        workbook
    ) {

        const sheet =
            workbook.addWorksheet(
                "README"
            );

        sheet.getColumn(1)
            .width = 30;

        sheet.getColumn(2)
            .width = 80;

        const rows = [
            [
                "SEKIN – BẢNG CHẤM CÔNG",
                "",
            ],

            [
                "",
                "",
            ],

            [
                "Thông tin",
                "Giá trị",
            ],

            [
                "Nguồn dữ liệu",
                "ProjectTimekeeping",
            ],

            [
                "Mục đích",
                "Bảng chấm công tháng của mục tiêu",
            ],

            [
                "Quy ước",
                "Giờ thường ghi trực tiếp; giờ tăng ca ghi trong ngoặc.",
            ],

            [
                "Ví dụ",
                "12 = 12 giờ thường; 12(4) = 12 giờ thường + 4 giờ OT.",
            ],

            [
                "Tổng ngày",
                "Tổng giờ thường / 12.",
            ],

            [
                "Template",
                "SEKIN MASTER XLSX",
            ],
        ];

        rows.forEach(
            (
                row,
                index
            ) => {

                sheet.getRow(
                    index + 1
                ).values =
                    row;
            }
        );

        sheet.getRow(
            1
        ).font = {
            bold:
                true,
            size:
                14,
        };

        sheet.getRow(
            3
        ).font = {
            bold:
                true,
        };

        return sheet;
    }

    // =========================================================
    // EXPORT
    // =========================================================

    async handleExport() {

        const {
            project,
        } = this.props;

        if (
            !project ||
            helps.isEmpty(
                project
            )
        ) {

            alert(
                "Không xác định được mục tiêu cần xuất bảng chấm công."
            );

            return;
        }

        try {

            console.log(
                "[SEKIN] ========================================"
            );

            console.log(
                "[SEKIN] START CLEAN XLSX EXPORT"
            );

            console.log(
                "[SEKIN] ========================================"
            );

            // =================================================
            // 1. DATA
            // =================================================

            const exportData =
                this.buildExportData();

            console.log(
                "[SEKIN] Export rows:",
                exportData.length
            );

            if (
                exportData.length ===
                0
            ) {

                alert(
                    "Không có nhân viên để xuất bảng chấm công."
                );

                return;
            }

            const monthDate =
                this.getMonthDate();

            const daysInMonth =
                this.getDaysInMonth();

            // =================================================
            // 2. LOAD MASTER TEMPLATE
            // =================================================

            const templateUrl =
                "/templates/tpl_bang_cham_cong.xlsx";

            console.log(
                "[SEKIN] Loading MASTER template:",
                templateUrl
            );

            const response =
                await fetch(
                    templateUrl,
                    {
                        method:
                            "GET",

                        cache:
                            "no-store",
                    }
                );

            console.log(
                "[SEKIN] Template HTTP:",
                response.status
            );

            if (
                !response.ok
            ) {

                throw new Error(
                    `Không tải được template XLSX. HTTP ${response.status}`
                );
            }

            const contentType =
                response.headers.get(
                    "content-type"
                ) || "";

            console.log(
                "[SEKIN] Template Content-Type:",
                contentType
            );

            if (
                contentType.includes(
                    "text/html"
                )
            ) {

                throw new Error(
                    "Server trả về HTML thay vì XLSX. Kiểm tra /public/templates/tpl_bang_cham_cong.xlsx"
                );
            }

            const arrayBuffer =
                await response.arrayBuffer();

            console.log(
                "[SEKIN] Template size:",
                arrayBuffer.byteLength,
                "bytes"
            );

            // =================================================
            // 3. LOAD TEMPLATE CHỈ ĐỂ LẤY STYLE
            // =================================================

            const templateWorkbook =
                new ExcelJS.Workbook();

            await templateWorkbook.xlsx.load(
                arrayBuffer
            );

            const templateWorksheet =
                templateWorkbook.getWorksheet(
                    "Bảng chấm công"
                ) ||
                templateWorkbook.worksheets[0];

            if (
                !templateWorksheet
            ) {

                throw new Error(
                    "Không tìm thấy worksheet Bảng chấm công trong template."
                );
            }

            console.log(
                "[SEKIN] Template worksheet:",
                templateWorksheet.name
            );

            // =================================================
            // 4. PROJECT INFO
            // =================================================

            const projectName =
                project.name ||
                project.title ||
                "";

            let areaName =
                "";

            if (
                project.area_name
            ) {

                areaName =
                    project.area_name;

            } else if (
                project.area &&
                project.area.name
            ) {

                areaName =
                    project.area.name;

            } else if (
                Array.isArray(
                    project.areas
                )
            ) {

                areaName =
                    project.areas
                        .filter(
                            Boolean
                        )
                        .map(
                            (
                                area
                            ) =>
                                area &&
                                area.name
                        )
                        .filter(
                            Boolean
                        )
                        .join(
                            ", "
                        );
            }

            console.log(
                "[SEKIN] Project:",
                projectName
            );

            console.log(
                "[SEKIN] Area:",
                areaName
            );

            // =================================================
            // 5. CREATE CLEAN WORKBOOK
            // =================================================

            const workbook =
                await this.createCleanWorkbook(
                    templateWorksheet,
                    exportData,
                    monthDate,
                    daysInMonth,
                    projectName,
                    areaName
                );

            // =================================================
            // 6. README
            // =================================================

            this.createReadme(
                workbook
            );

            // =================================================
            // 7. CALCULATION
            // =================================================

            if (
                workbook.calcProperties
            ) {

                workbook
                    .calcProperties
                    .fullCalcOnLoad =
                    true;

                workbook
                    .calcProperties
                    .forceFullCalc =
                    true;

                workbook
                    .calcProperties
                    .calcMode =
                    "auto";
            }

            // =================================================
            // 8. VERIFY CLEAN WORKBOOK
            // =================================================

            const worksheet =
                workbook.getWorksheet(
                    "Bảng chấm công"
                );

            const verifyFirstRow =
                9;

            const verifyLastRow =
                9 +
                exportData.length -
                1;

            const verifyTotalRow =
                9 +
                exportData.length;

            console.log(
                "[SEKIN] ========================================"
            );

            console.log(
                "[SEKIN] VERIFY CLEAN WORKBOOK"
            );

            console.log(
                "[SEKIN] ========================================"
            );

            console.log(
                "[SEKIN] First employee row:",
                verifyFirstRow
            );

            console.log(
                "[SEKIN] Last employee row:",
                verifyLastRow
            );

            console.log(
                "[SEKIN] Total row:",
                verifyTotalRow
            );

            console.log(
                "[SEKIN] A9:",
                worksheet.getCell(
                    "A9"
                ).value
            );

            console.log(
                "[SEKIN] B9:",
                worksheet.getCell(
                    "B9"
                ).value
            );

            console.log(
                "[SEKIN] C9:",
                worksheet.getCell(
                    "C9"
                ).value
            );

            console.log(
                "[SEKIN] AH9:",
                worksheet.getCell(
                    "AH9"
                ).value
            );

            console.log(
                "[SEKIN] AI9:",
                worksheet.getCell(
                    "AI9"
                ).value
            );

            console.log(
                "[SEKIN] B" +
                verifyLastRow +
                ":",
                worksheet.getCell(
                    verifyLastRow,
                    2
                ).value
            );

            console.log(
                "[SEKIN] AH" +
                verifyLastRow +
                ":",
                worksheet.getCell(
                    verifyLastRow,
                    34
                ).value
            );

            console.log(
                "[SEKIN] AI" +
                verifyLastRow +
                ":",
                worksheet.getCell(
                    verifyLastRow,
                    35
                ).value
            );

            console.log(
                "[SEKIN] TOTAL AH:",
                worksheet.getCell(
                    verifyTotalRow,
                    34
                ).value
            );

            console.log(
                "[SEKIN] TOTAL AI:",
                worksheet.getCell(
                    verifyTotalRow,
                    35
                ).value
            );

            console.log(
                "[SEKIN] ========================================"
            );

            // =================================================
            // 9. WRITE BUFFER
            // =================================================

            console.log(
                "[SEKIN] Generating CLEAN XLSX..."
            );

            const outputBuffer =
                await workbook.xlsx.writeBuffer();

            console.log(
                "[SEKIN] CLEAN XLSX generated:",
                outputBuffer.byteLength,
                "bytes"
            );

            // =================================================
            // 10. DOWNLOAD
            // =================================================

            const safeProjectName =
                this.sanitizeFileName(
                    projectName
                );

            const monthText =
                String(
                    monthDate.getMonth() +
                    1
                ).padStart(
                    2,
                    "0"
                ) +
                "-" +
                monthDate.getFullYear();

            const fileName =
                `SEKIN_BẢNG_CHẤM_CÔNG_${safeProjectName}_${monthText}.xlsx`;

            const blob =
                new Blob(
                    [
                        outputBuffer,
                    ],
                    {
                        type:
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    }
                );

            console.log(
                "[SEKIN] Saving file:",
                fileName
            );

            saveAs(
                blob,
                fileName
            );

            console.log(
                "[SEKIN] ========================================"
            );

            console.log(
                "[SEKIN] EXPORT COMPLETED SUCCESSFULLY"
            );

            console.log(
                "[SEKIN] ========================================"
            );

        } catch (
        error
        ) {

            console.error(
                "[SEKIN] ========================================"
            );

            console.error(
                "[SEKIN] EXPORT ERROR"
            );

            console.error(
                error
            );

            console.error(
                error &&
                error.stack
            );

            console.error(
                "[SEKIN] ========================================"
            );

            alert(
                "Không thể xuất bảng chấm công Excel.\n\n" +
                (
                    error &&
                        error.message
                        ? error.message
                        : "Lỗi không xác định."
                )
            );
        }
    }

    // =========================================================
    // RENDER
    // =========================================================

    render() {

        return (
            <CRow>

                <CCol
                    xl={12}
                    md={12}
                >

                    <CTooltip
                        content={
                            "Export to Excel"
                        }
                    >

                        <CButton
                            color="info"
                            size="sm"
                            title="Export Excel"
                            className="ml-1"
                            onClick={
                                this.handleExport
                            }
                        >

                            <CIcon
                                name="cil-save"
                                className="mfe-1 mt-0"
                            />

                            Export

                        </CButton>

                    </CTooltip>

                </CCol>

            </CRow>
        );
    }
}